class Swiss {
	constructor(axios, baseUrl) {
		this.axios = axios
		this.baseUrl = baseUrl
	}

	getSwissRecords(segmentId, roundNumber, token) {
		return this.axios.get(
			`${this.baseUrl}/segments/${segmentId}/swiss-records?filter[roundNumber]=${roundNumber}&page[size]=50`,
			{
				headers: {
					...(token ? { Authorization: 'Bearer ' + token } : {}),
					Accept: 'application/json',
				},
			}
		)
	}
}

export default ({ $axios, $config }, inject) => {
	const swiss = $axios.create()
	inject('swiss', new Swiss(swiss, `${$config.apiBaseUrl}/matches/1.0`))
}
